import React from "react";
import { useSelector } from "react-redux";
import { AccessibilityPopup } from '@skillz/accessibility';
import { deviceTypes } from "../../../../enums/deviceTypes";
import classes from "./HeaderPopup.module.css"

const HeaderPopup = ({ children, className, accessibilityDescription}) => {

    const { deviceType } = useSelector(state => state.responsive);

    return (
        deviceType != deviceTypes.mobile ?
            <AccessibilityPopup accessibilityDescription={accessibilityDescription} close={() => console.log('close')}>
                <div className={`${classes.HeaderPopup} ${className}`} >
                    {children}
                </div>
            </AccessibilityPopup>
            : null
    )
}

export default HeaderPopup;